
import homeTab from '~/components/home/homeT.vue'
export default {
  components: {
    homeTab
  },
    props: {
        relatesList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            isShow: false,
            defaultType: 0,
            showLength: 6,
            initDataList: []
        }
    },
    computed: {
      tabList () {
        const tempList =  this.relatesList.map((item => {
           item.code = item.relatedName + item.companyRelationshipType
           const num = item.itemCount > 1 ? item.itemCount : ''
           item.name = item.relatedName + ' ' + num
           return item
        }))
        return tempList
      }
    },
    created() {
    },
    mounted() {
        this.initData()
    },
    methods: {
      initDocument () {
         const clientWidth = document && document.documentElement && document.documentElement.clientWidth
           if (clientWidth <= 799) {
              this.showLength = 3 
            } else if (clientWidth <= 1200) {
              this.showLength = 4
            }
      },
        initData () {
            this.initDocument()
            this.relatesList.forEach((el, index) => {
              const tempObj = {
                items: el.items.slice(0, this.showLength),
                isShowMore: el.items.length > this.showLength,
                isUnfold: false
              }
              this.initDataList.push(tempObj)
            });
        },
        companyTabClick (item, i) {
            this.defaultType = i
            this.initData()
        },
        moreClick() {
            // this.initDataList[this.defaultType].isShowMore = !this.initDataList[this.defaultType].isShowMore
            // this.initDataList[this.defaultType].items = this.relatesList[this.defaultType].items
             this.initDataList[this.defaultType].isUnfold = !this.initDataList[this.defaultType].isUnfold
            if (!this.initDataList[this.defaultType].isUnfold) {
              this.initDataList[this.defaultType].items = this.relatesList[this.defaultType].items.slice(0, this.showLength)
            } else {
              this.initDataList[this.defaultType].items = this.relatesList[this.defaultType].items
            }
        }
    },  
}
